import script from "./index.vue?vue&type=script&setup=true&name=MyIcon&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=MyIcon&lang=js"

const __exports__ = script;

export default __exports__